export const App = {
    URL: 'https://skistem-3cc57.web.app/',
};
